const AppInfo = {
    name: "PeaColony",// "Peetree",//'Colony',
    version: '0.0.1',
    // tagLine: `A Limited Size Group Chat With Shared Traits And Interests All To Maximize Intimacy Friendship, & A Good Time`, //'A Decentralized Community of Friends With Deeply Centralized Interests',
    // description: `PeaColony Is A Limited Size Group Chat With Shared Traits And Interets All To Maximize Intimacy, Friendship, & A Good Time`,
    tagLine: "Visual inspiration meets genuine social connection!", //`A Limited Sized Group Chat Built Like Your Own Social Network`,
    description: "Organize ideas, share passions in limited-size group chats, and make real friends."
    // description: `Create a colony around shared interests, personal traits, identity, and more. It's large enough to feel lively, but small enough to build close connections.`,
}

export default AppInfo;
// A Limited Size Community of Friends With Shared Traits, Interests, And Other Things

//     description: "Your assigned to a community with a fixed number of people just like you. \n All you have to do is answer some questions and we will find a place for you.",
